import { Col, Form, FormControl, FormGroup, Row } from "react-bootstrap";

import { useTranslateContext } from "../../contexts/translate.context";
import styles from './common-area.record.module.scss'
import { Tooltip as TooltipMaterial } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ImageLightBox from "../../components/image-lightbox/ImageLightbox";

export interface ICommonAreaRecordProps {
    title: any,
    isEdit: boolean,
    identifier: boolean,
    viewOnly?: boolean,

    created?: any,
    updated?: any,
    setCreated?: any,
    setUpdated?: any,

    name: any,
    observation: any,
    setName: any,
    setObservation: any,
    image?:any,
    changeImage?: any
}

export const CommonAreaRecord: React.FC<ICommonAreaRecordProps> = (props: ICommonAreaRecordProps) => {

    const { display } = useTranslateContext();

    return (
        <>
            <Row>
                <fieldset>
                    <legend>Dados Gerais</legend>
                    <FormGroup>
                        <Form.Label htmlFor="form-name">{display.label.name}</Form.Label>
                        <FormControl id="form-name" name="name" placeholder={display.example.name}
                            value={props.name}
                            onChange={e => props.setName(e.target.value)}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Form.Label htmlFor="form-observation">{display.label.observation}</Form.Label>
                        <FormControl id="form-observation" name="observation" placeholder={display.example.observation}
                            value={props.observation}
                            onChange={e => props.setObservation(e.target.value)}
                        />
                    </FormGroup>
                </fieldset>
            </Row>
            <Row>
                <fieldset>
                    <legend>Foto</legend>
                    <div className='d-flex flex-column justify-content-center align-items-center'>
                        <ImageLightBox containerStyle={`${styles.imageWrapper}
                            ${styles.inImage} mb-3`} src={props.image}
                            alt={'Imóvel'}/>
                        {!props.viewOnly && <FormGroup as={Row} className={`d-flex
                            justify-content-center ${styles.imageControls}`}>
                            <label htmlFor={`common-area-image`}>
                                <TooltipMaterial className="isClickable"
                                    title="Fazer upload de nova foto">
                                    <CloudUploadIcon />
                                </TooltipMaterial>
                            </label>
                            <label className="text-right">
                                <TooltipMaterial className="isClickable ms-2"
                                    title="Remover foto atual">
                                    <HighlightOffIcon onClick={(e)=> props.changeImage(e)}/>
                                </TooltipMaterial>
                            </label>
                            <Form.Control type='file'
                                id={`common-area-image`}
                                accept="image/*"
                                onChange={(e)=> props.changeImage(e)} />
                        </FormGroup>}
                    </div>
                </fieldset>
            </Row>
        </>
    );

}

export default CommonAreaRecord;
